import React from "react";

const isMobile = window.innerWidth < 600;

export default function Header() {
  return (
    <header className="app-header">
      <div className="app-logo">
        <div className="app-logo-icon">DV</div>
        <div className="app-logo-text ">
          <h1 className="mb-0">
            {isMobile
              ? "LMIS"
              : "Logistic Management Information System"}
          </h1>
          <p className="m-0 ">
            {isMobile ? (
              <>
                Assam State Health Department
                <br />
                Supply Chain Intelligence
              </>
            ) : (
              "Assam State Health Department \u2022 Supply Chain Intelligence"
            )}
          </p>
        </div>
      </div>
      <div className="header-actions">
        <span className="hdr-pill">{"\uD83D\uDFE2"} Live Data</span>
        <span className="hdr-pill">Assam State</span>
        <span className="hdr-time">Last refreshed: 12 Mar 2026, 09:45 AM</span>
      </div>
    </header>
  );
}
